import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FloaterTooltipMarkdown, Icon } from '@honda-canada/design-system-react';
const SpecialOffersTooltipAnchor = ({ children, iconName = 'information', ...others }) => (_jsx(FloaterTooltipMarkdown, { as: "span", content: children, ariaLabel: children, styling: "light", ...others, children: () => _jsx(Icon, { name: iconName }) }));
export default SpecialOffersTooltipAnchor;
